import type { ReactNode } from "react";
import { Logo } from "@/components/ui/Logo";

interface AuthLayoutProps {
  children: ReactNode;
}

/**
 * Layout wrapper for authentication pages.
 * Uses semantic color tokens from the design system.
 * @param props - Component props
 * @param props.children - Child components to render
 * @returns The auth layout with header and footer
 */
export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      {/* Header */}
      <header className="border-b border-neutral-200 bg-surface">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Logo asLink />
        </div>
      </header>

      {/* Main content */}
      <main className="flex flex-1 items-center justify-center p-4 sm:p-6 lg:p-8">
        <div className="w-full max-w-sm">{children}</div>
      </main>

      {/* Footer */}
      <footer className="border-t border-neutral-200 bg-surface py-4">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <p className="text-center text-sm text-neutral-500">
            &copy; {new Date().getFullYear()} RideReserv. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
